import React from 'react'
import './Footer.css'

function Footer() {
    return (
        <div className='footer'>
            <p>Airnbnb clone! No rights reseved - this is a demo! Kodluyoruz</p>
            <p>Privacy . Terms . Sitemap . Company Details</p>
        </div>
    )
}

export default Footer
